import { render, staticRenderFns } from "./v-4.vue?vue&type=template&id=2fb0fb1d&scoped=true&"
import script from "./v-4.vue?vue&type=script&lang=js&"
export * from "./v-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0fb1d",
  null
  
)

export default component.exports